import React, { FC, useEffect, useState } from "react";
import styled from "styled-components";

import { Icon } from "../../../../../../../components/atoms";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "../../../../../../../store/Store";
import { GetUserWallet } from "../../../../../../../store/actions/user/UserActions";
import buildClassName from "../../../../../../../utils/buildClassName";
import { useTranslation } from "react-i18next";

const StyledAnimationRefresh = styled.div`
  &.active {
    img {
      -webkit-animation: spin 2s linear infinite;
      -moz-animation: spin 2s linear infinite;
      animation: spin 2s linear infinite;
    }
    @-moz-keyframes spin {
      100% {
        -moz-transform: rotate(360deg);
      }
    }
    @-webkit-keyframes spin {
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
    @keyframes spin {
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }
`;

const BalanceAndCurrencyHolder = styled.div<OwnProps>`
  display: flex;
  align-items: center;
  flex-direction: ${(p) => {
    return p.currency === "IRT" ? "row" : "row-reverse";
  }};
  span {
    margin: ${(p) => {
      return p.currency === "IRT" ? "0 0 0 0.5rem" : "0 0.5rem 0 0";
    }};
  }
`;

const TetherCap = styled.div`
  span {
    font-size: 16px;
    font-weight: 400;
    margin-inline-start: 0.5rem;
  }
`;

type OwnProps = {
  currency?: "IRT" | "USDT";
};
const UserBalanceAndRefresh: FC<OwnProps> = ({ currency = "IRT" }) => {
  let UserState = useSelector((state: RootStore) => state.user);

  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const {t} = useTranslation();

  const [irtBalance, setIrtBalance] = useState<number>(0);

  useEffect(() => {
    let userWallet = UserState.wallet;
    if (UserState.wallet?.length > 0) {
      const currencyWallet = userWallet?.find(
        (item: { currency: string }) => item.currency === currency
      );
      if (currencyWallet) {
        setIrtBalance(currencyWallet?.effectiveBalance * 10 || 0);
      }
    }
  }, [UserState.wallet]);

  //TODO Detect Get User Wallet Done From Store State
  const handleRefreshBalance = () => {
    dispatch(GetUserWallet());
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 5000);
  };

  return (
    <>
      {currency === "IRT" ? (
        <span className="title">{t("deposit.balance")}</span>
      ) : (
        <TetherCap>
          <Icon name="tetherIcon" width="20px" height="20px" />
          <span>{t("deposit.tetherBalance")}</span>
        </TetherCap>
      )}

      <div className="refresh-balance-row">
        <StyledAnimationRefresh
          className={buildClassName(
            "refresh-balance ml-2",
            isLoading && "active"
          )}
          onClick={handleRefreshBalance}
        >
          <Icon name="refreshBalance" width="24px" height="24px" />
        </StyledAnimationRefresh>
        <BalanceAndCurrencyHolder>
          <span>{irtBalance.toLocaleString()}</span>
          {currency === "IRT" ? <span style={{ paddingInlineStart: "5px" }}>{t("deposit.irr")}</span> : <span>USDT</span>}
        </BalanceAndCurrencyHolder>
      </div>
    </>
  );
};

export default UserBalanceAndRefresh;
